import { ONBOARDING_START, ONBOARDING_NEXT_STEP, ONBOARDING_SKIP, ONBOARDING_COMPLETE, SET_ONBOARDING_STATUS, RESET_ONBOARDING } from "../../actions/onboarding";

const initialState = {
    run: false,
    currentStep: 0,
    completed: false,
  }
export const onboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ONBOARDING_START:
      return {
        ...state,
        run: true,
      };
    case ONBOARDING_NEXT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1,
      };
    case ONBOARDING_SKIP:
      return {
        ...state,
        run: false,
        currentStep: 0,
        completed: true,
      };
    case ONBOARDING_COMPLETE:
      return {
        ...state,
        run: false,
        currentStep: 0,
        completed: true,
      };
    case SET_ONBOARDING_STATUS:
      return {
        ...state,
        completed: action.payload,
      };
    case RESET_ONBOARDING:
      return {
        ...state,
        run: true,
        currentStep: 0,
        completed: false,
      };
    default:
      return state;
}}